<template>
  <div class="min-h-full min-h-[100dvh] bg-surface-muted text-content" @mousedown="com_SetLastActivityTime">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAdminCommon } from '@/composables/useAdminCommon'
import { initResponsiveTables } from '@/composables/useResponsiveTables'
import { initTheme } from '@/composables/useTheme'

const { com_SetLastActivityTime } = useAdminCommon()

onMounted(() => {
  initTheme()
  initResponsiveTables()
})
</script>
